import { all, call, cancelled, put, takeLatest } from "redux-saga/effects";
import RewardService from "../../services/RewardService";
import {
  createFail,
  createSuccess,
  deleteFail,
  deleteSuccess,
  detailsFail,
  detailsSuccess,
  listFail,
  listSuccess,
  updateDetailFail,
  updateDetailSuccess,
  associationsFail,
  associationsSuccess,
} from "../slices/rewardSlice";

function* list(data) {
  try {
    const ajax = yield call(RewardService.list, data.payload);
    if (ajax.status === 200) {
      yield put(listSuccess(ajax.data));
    } else {
      yield put(
        listFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      listFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* details(data) {
  try {
    const ajax = yield call(RewardService.details, data.payload);
    if (ajax.status === 200) {
      yield put(detailsSuccess(ajax.data));
    } else {
      yield put(
        detailsFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      detailsFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* create(data) {
  try {
    const ajax = yield call(RewardService.create, data.payload);
    if (ajax.status === 200) {
      yield put(createSuccess(ajax.data));
    } else {
      yield put(
        createFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      createFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* update(data) {
  try {
    const ajax = yield call(RewardService.update, data.payload);
    if (ajax.status === 200) {
      yield put(updateDetailSuccess(ajax.data));
    } else {
      yield put(
        updateDetailFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      updateDetailFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* deleteReward(data) {
  try {
    const ajax = yield call(RewardService.delete, data.payload);
    if (ajax.status === 200) {
      yield put(deleteSuccess(ajax.data));
    } else {
      yield put(
        deleteFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      deleteFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      // Handle saga cancellation (e.g., decrement the counter)
      yield put({ type: "cancel" });
    }
  }
}

function* associations(data) {
  try {
    const ajax = yield call(RewardService.associations, data.payload);
    if (ajax.status === 200) {
      yield put(
        associationsSuccess({
          ...ajax.data,
          query: { ...data.payload },
        })
      );
    } else {
      yield put(
        associationsFail({
          status: ajax.status,
          errors: ajax.data,
        })
      );
    }
  } catch (error) {
    yield put(
      associationsFail({
        status: 400,
        response: "SOMETHING_ELSE_WRONG",
        ...(error?.response?.data || {}),
      })
    );
  } finally {
    if (yield cancelled()) {
      yield put({ type: "cancel" });
    }
  }
}

export default function* rewardSaga() {
  yield all([
    takeLatest("rewards/listRequest", list),
    takeLatest("rewards/createRequest", create),
    takeLatest("rewards/detailsRequest", details),
    takeLatest("rewards/updateDetailRequest", update),
    takeLatest("rewards/deleteRequest", deleteReward),
    takeLatest("rewards/associationsRequest", associations),
  ]);
}
